<template>
  <div>
    <v-progress-linear
      v-show="loading"
      indeterminate
      class="my-0"
    />
    <div v-show="!loading" style="height: 7px;"></div>
    <v-list
      :dense="!!$route.params.id"
      two-line
      class="list"
    >
      <v-list-tile
        v-for="item in items"
        :key="item._id"
        :to="`/admin/${service}/${item._id}`"
        exact
      >
        <v-list-tile-content>
          <v-list-tile-title class="text-capitalize">{{ item.name }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ item.subname }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div v-if="totalPages > 1" class="justify-center d-flex">
      <v-pagination
        v-model="page"
        :key="$route.params.id"
        :length="totalPages"
        style="display: contents;"
      />
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import debouncePromise from 'debounce-promise';
import { searchQuery } from '../../../lib/searchRegex';

export default {
  props: {
    service: {
      type: String,
      default: 'users',
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      items: [],
      page: 1,
      limit: 25,
      total: 0,
      loading: true,
      loadItemsDebounced: debouncePromise(this.loadItems, 500),
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },
    key() {
      return `${this.service}-${this.page}-${this.search}`;
    },
  },
  mounted() {
    this.loadItemsDebounced();
  },
  watch: {
    key(to, from) {
      if (to !== from) {
        this.loading = true;
        this.loadItemsDebounced();
      }
    },
    service(to, from) {
      if (to !== from) this.page = 1;
    },
    search(to, from) {
      if (to !== from) this.page = 1;
    },
  },
  methods: {
    async loadItems() {
      this.loading = true;
      const res = await this.$cacheFind.find('admin-list', this.service, this.key, {
        ...searchQuery(this.search, this.service),
        $limit: this.limit,
        $skip: (this.page - 1) * this.limit,
        $client: { paginate: { default: 100 } },
      });
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.list
  max-height 70vh
  overflow-y auto
</style>
